<template>
  <svg :width="svgWidth" :height="svgHeight" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 22.75C6.07 22.75 1.25 17.93 1.25 12C1.25 6.07 6.07 1.25 12 1.25
      C17.93 1.25 22.75 6.07 22.75 12C22.75 17.93 17.93 22.75 12 22.75
      ZM12 2.75C6.9 2.75 2.75 6.9 2.75 12C2.75 17.1 6.9 21.25 12 21.25
      C17.1 21.25 21.25 17.1 21.25 12C21.25 6.9 17.1 2.75 12 2.75Z"
      :fill="color ? color : theme === 'light' ? '#292D32' : '#fff'"
      @mouseover="isHover = true"
      @mouseout="isHover = false"
    />
    <path
      d="M9.00023 21.75H8.00023C7.59023 21.75 7.25023 21.41 7.25023 21
      C7.25023 20.59 7.57023 20.26 7.98023 20.25
      C6.41023 14.89 6.41023 9.11 7.98023 3.75
      C7.57023 3.74 7.25023 3.41 7.25023 3C7.25023 2.59 7.59023 2.25 8.00023 2.25
      H9.00023C9.24023 2.25 9.47023 2.37 9.61023 2.56
      C9.75023 2.76 9.79023 3.01 9.71023 3.24C7.83023 8.89 7.83023 15.11 9.71023 20.77
      C9.79023 21 9.75023 21.25 9.61023 21.45C9.47023 21.63 9.24023 21.75 9.00023 21.75Z"
      :fill="color ? color : theme === 'light' ? '#292D32' : '#fff'"
      @mouseover="isHover = true"
      @mouseout="isHover = false"
    />
    <path
      d="M15.0004 21.7507C14.9204 21.7507 14.8404 21.7407 14.7604 21.7107
      C14.3704 21.5807 14.1504 21.1507 14.2904 20.7607
      C16.1704 15.1107 16.1704 8.89067 14.2904 3.23067
      C14.1604 2.84067 14.3704 2.41067 14.7604 2.28067
      C15.1604 2.15067 15.5804 2.36067 15.7104 2.75067
      C17.7004 8.71067 17.7004 15.2707 15.7104 21.2207
      C15.6104 21.5507 15.3104 21.7507 15.0004 21.7507Z"
      :fill="color ? color : theme === 'light' ? '#292D32' : '#fff'"
      @mouseover="isHover = true"
      @mouseout="isHover = false"
    />
    <path
      d="M12 17.2008C9.21 17.2008 6.43 16.8108 3.75 16.0208
      C3.74 16.4208 3.41 16.7508 3 16.7508C2.59 16.7508 2.25 16.4108 2.25 16.0008
      V15.0008C2.25 14.7608 2.37 14.5308 2.56 14.3908C2.76 14.2508 3.01 14.2108 3.24 14.2908
      C8.89 16.1708 15.12 16.1708 20.77 14.2908C21 14.2108 21.25 14.2508 21.45 14.3908
      C21.65 14.5308 21.76 14.7608 21.76 15.0008V16.0008
      C21.76 16.4108 21.42 16.7508 21.01 16.7508C20.6 16.7508 20.27 16.4308 20.26 16.0208
      C17.57 16.8108 14.79 17.2008 12 17.2008Z"
      :fill="color ? color : theme === 'light' ? '#292D32' : '#fff'"
      @mouseover="isHover = true"
      @mouseout="isHover = false"
    />
    <path
      d="M12 17.2008C9.21 17.2008 6.43 16.8108 3.75 16.0208
      C3.74 16.4208 3.41 16.7508 3 16.7508C2.59 16.7508 2.25 16.4108 2.25 16.0008
      V15.0008C2.25 14.7608 2.37 14.5308 2.56 14.3908C2.76 14.2508 3.01 14.2108 3.24 14.2908
      C8.89 16.1708 15.12 16.1708 20.77 14.2908C21 14.2108 21.25 14.2508 21.45 14.3908
      C21.65 14.5308 21.76 14.7608 21.76 15.0008V16.0008
      C21.76 16.4108 21.42 16.7508 21.01 16.7508C20.6 16.7508 20.27 16.4308 20.26 16.0208
      C17.57 16.8108 14.79 17.2008 12 17.2008Z"
      :fill="color ? color : theme === 'light' ? '#292D32' : '#fff'"
      @mouseover="isHover = true"
      @mouseout="isHover = false"
    />
    <path
      d="M20.9998 9.74938C20.9198 9.74938 20.8398 9.73938 20.7598 9.70938
      C15.1098 7.82938 8.87978 7.82938 3.22978 9.70938
      C2.82978 9.83938 2.40978 9.62937 2.27978 9.23937
      C2.15978 8.83937 2.36978 8.41938 2.75978 8.28938
      C8.71978 6.29938 15.2798 6.29938 21.2298 8.28938
      C21.6198 8.41938 21.8398 8.84937 21.6998 9.23937
      C21.6098 9.54937 21.3098 9.74938 20.9998 9.74938Z"
      :fill="color ? color : theme === 'light' ? '#292D32' : '#fff'"
      @mouseover="isHover = true"
      @mouseout="isHover = false"
    />
  </svg>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    width: {
      type: String,
      default: '20',
    },
    height: {
      type: String,
      default: '20',
    },
    color: {
      type: String,
    },
  },
  data() {
    return {
      isHover: false,
    };
  },
  computed: {
    ...mapGetters({ theme: 'getTheme' }),
    svgWidth() {
      return this.width;
    },
    svgHeight() {
      return this.height;
    },
  },
};
</script>
